import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelDCandidateListResponse, LevelDReportFilter } from "../../types/leveld-reports";

interface UseGetLevelDCandidatesParams {
  filter: LevelDReportFilter;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}

export const useGetLevelDCandidates = ({
  filter,
  search,
  sortBy = 'examDate',
  sortOrder = 'desc',
  page = 1,
  pageSize = 25,
  enabled = true,
}: UseGetLevelDCandidatesParams) => {
  const axios = useAxios();
  const { t } = useTranslation();

  const fetchCandidates = async (): Promise<LevelDCandidateListResponse> => {
    try {
      const params = new URLSearchParams({
        startDate: filter.startDate,
        endDate: filter.endDate,
        sortBy,
        sortOrder,
        page: page.toString(),
        pageSize: pageSize.toString(),
      });

      if (filter.examTermId) {
        params.append('examTermId', filter.examTermId);
      }
      if (filter.examId) {
        params.append('examId', filter.examId);
      }
      if (search) {
        params.append('search', search);
      }

      const { data } = await axios.get(`/api/leveldreports/candidates?${params.toString()}`);
      return data;
    } catch (error) {
      throw new Error(t("levelDReports.errors.getCandidates"));
    }
  };

  return useQuery({
    queryKey: ["levelDCandidates", filter, search, sortBy, sortOrder, page, pageSize],
    queryFn: fetchCandidates,
    enabled: enabled && Boolean(filter.startDate) && Boolean(filter.endDate),
  });
};
